<div class="container mt-4" style="min-height: calc(100vh - 300px);">
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <h5 class="font-medium m-0">📄 Inspection Details</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <!-- <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Block Office<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Financial/Reporting Year<sup class="text-danger">*</sup></label>
                            <select class="form-control">
                                <option value="" selected disabled>--Select--</option>
                            </select>
                        </div> -->
                        <form [formGroup]="targetForm" (ngSubmit)="GetInspectionCSTarget()">
                            <div class="row align-items-end">

                                                               <div class="col-lg-4 col-md-6 mb-2" *ngIf="this.UserDetails?.roleId == 1">
                <label class="form-label">Circle Office <span class="text-danger">*</span></label>
                <select class="form-control" formControlName="circleOffice" (change)="GetBlock()">
                  <option value="">--Select--</option>
                  <option *ngFor="let circle of circlesList" [value]="circle?.iCircleId">
                    {{ circle?.sCircleName }}
                  </option>
                </select>
                <div *ngIf="targetForm.get('circleOffice')?.touched && targetForm.get('circleOffice')?.invalid"
                  class="text-danger small">
                  Circle office is required
                </div>
              </div>
                                <!-- Block Office -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Block Office <span class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="blockOffice">
                                        <option value="" selected>--Select--</option>
                                        <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                            {{ circle?.sBlockName }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('blockOffice')?.touched && targetForm.get('blockOffice')?.invalid"
                                        class="text-danger small">
                                        block Office is required
                                    </div>
                                </div>

                                <!-- Financial Year -->
                                <div class="col-lg-4 col-md-6 mb-2">
                                    <label class="form-label">Financial/Reporting Year <span
                                            class="text-danger">*</span></label>
                                    <select class="form-control" formControlName="financialYear">
                                        <option value="">--Select--</option>
                                        <option *ngFor="let years of financialYears" [ngValue]="years">
                                            {{ years?.financialYear }}
                                        </option>
                                    </select>
                                    <div *ngIf="targetForm.get('financialYear')?.touched && targetForm.get('financialYear')?.invalid"
                                        class="text-danger small">
                                        Financial year is required
                                    </div>
                                </div>

                                <!-- Submit -->
                                <div class="col-lg-12 text-end">
                                    <button type="submit" class="btn btn-primary" [disabled]="targetForm.invalid">
                                        Get Report
                                    </button>
                                </div>

                            </div>
                        </form>
                        <!-- 
                        <div class="col-lg-12 text-end">
                            <button type="button" class="btn btn-primary">Get Report</button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <div class="d-flex align-items-center justify-content-between">
                        <h5 class="font-medium m-0">📄Report</h5>
                        <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal"
                            data-bs-target="#ConsumerGoodsDistributionDataModal" (click)="addData()"
                           c>+ Add
                            Inspection Data</button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                       <table class="table table-bordered" style="min-width: 768px;">
  <thead>
    <tr class="texture font-size-12 text-center">
      <th style="width: 3%">Sr. No.</th>
      <th>Month</th>
      <th>Target for Month</th>
      <th>Target up to Month</th>
      <th>Inspections during Month</th>
      <th>Inspections up to Month</th>
      <th>Arrear</th>
      <th style="width: 10%">Action</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of inspectionData; let i = index">
      <td class="text-center">{{ i + 1 }}</td>
      <td>{{ getMonthName(row?.dataMonth, row?.financialYear) }}</td>
      <td class="text-end">{{ row?.targetForMonth }}</td>
      <td class="text-end">{{ row?.targetUptoMonth }}</td>
      <td class="text-end">{{ row?.inspectionsDuringMonth }}</td>
      <td class="text-end">{{ row?.inspectionsUptoMonth }}</td>
      <td class="text-end">{{ row?.arrear }}</td>
      <td>
        <div class="d-flex align-items-center gap-1">
        <ng-container *ngIf="!row.isVerified && ( this.UserDetails?.roleId ==11 || this.UserDetails?.roleId ==13 ); else verifiedBlock">
         <button type="button" class="btn btn-primary btn-sm" title="Click to Edit"
               (click)="editRow(row)">
              <i class="bi bi-pencil-square"></i>
            </button>
           <button type="button" class="btn btn-success btn-sm" title="Click to Verify" *ngIf="this.UserDetails?.roleId ==13"
               data-bs-toggle="modal" data-bs-target="#verifyConfirmModal" (click)="setDeleteIndex(row?.id)">
              <i class="bi bi-clipboard2-check"></i>
            </button>
            <button type="button" class="btn btn-danger btn-sm" title="Click to Delete" 
                data-bs-toggle="modal" data-bs-target="#deleteConfirmModal"
                                                (click)="setDeleteIndex(row?.id)">
              <i class="bi bi-trash3"></i>
            </button>
          
        </ng-container>
        <ng-template #verifiedBlock>
          <button type="button" class="btn btn-primary btn-sm" title="Verified">
            <i class="bi bi-lock"></i>
          </button>
        </ng-template>
        </div>
      </td>
    </tr>
  </tbody>
</table>
  <!-- Delete Confirmation Modal -->
                        <div class="modal fade" id="deleteConfirmModal" tabindex="-1"
                            aria-labelledby="deleteConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Delete</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to delete?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="cancelDelete()">Cancel</button>
                                        <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="DeleteInspectionCSTarget(deleteIndex)">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>

 <!-- verify Confirmation Modal -->
                        <div class="modal fade" id="verifyConfirmModal" tabindex="-1"
                            aria-labelledby="verifyConfirmModalLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="deleteConfirmModalLabel">Confirm Veriication</h5>
                                        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button> -->
                                    </div>
                                    <div class="modal-body">
                                        Are you sure you want to Verify?
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-bs-dismiss="modal" (click)="this.deleteIndex = 0;">Cancel</button>
                                        <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                                            aria-label="Close"
                                            (click)="verifyInspectionCSTarget(deleteIndex)">Verify</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Modal -->
                <div class="modal fade" id="ConsumerGoodsDistributionDataModal" data-bs-backdrop="static"
                    data-bs-keyboard="false" tabindex="-1" aria-labelledby="ConsumerGoodsDistributionDataModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl ">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h1 class="modal-title fs-5" id="ConsumerGoodsDistributionDataModalLabel">Add Inspection
                                    Details</h1>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">

                                <form [formGroup]="inspectionForm">
                                    <div class="row">
                                        <!-- Financial Year -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Financial/Reporting Year <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="financialYear">
                                                <option value="">--Select--</option>
                                                <option *ngFor="let years of financialYears" [ngValue]="years">
                                                    {{ years?.financialYear }}
                                                </option>
                                            </select>
                                            <div *ngIf="inspectionForm.get('financialYear')?.touched && inspectionForm.get('financialYear')?.invalid"
                                                class="text-danger small">
                                                Financial year is required
                                            </div>
                                        </div>


                                        <!-- Block Office -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Block Office <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="blockOffice">
                                                <option value="" selected>--Select--</option>
                                                <option *ngFor="let circle of blockList" [value]="circle?.iBlockId">
                                                    {{ circle?.sBlockName }}
                                                </option>
                                            </select>
                                            <div *ngIf="inspectionForm.get('blockOffice')?.touched && inspectionForm.get('blockOffice')?.invalid"
                                                class="text-danger small">
                                                block Office is required
                                            </div>
                                        </div>


                                        <!-- During Month -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">During Month <span
                                                    class="text-danger">*</span></label>
                                            <!-- <input class="form-control" type="month" formControlName="duringMonth" placeholder="e.g., May 2025" /> -->
                                            <select class="form-control" formControlName="dataMonth">
                                                <option value="" selected>--Select Month--</option>
                                                <option *ngFor="let month of months" [value]="month?.iMonthId">
                                                    {{ month?.sMonthName }}
                                                </option>
                                            </select>

                                            <div class="text-danger small" style="min-height: 1.25rem;">
                                                <span
                                                    *ngIf="inspectionForm.get('dataMonth')?.touched && inspectionForm.get('dataMonth')?.invalid">
                                                    This field is required
                                                </span>
                                            </div>
                                        </div>


                                        <!-- Cases as on Start -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label"> Target For {{ currentMonth?.name }}</label>
                                            <input type="number" min="0" step="1" class="form-control"
                                                formControlName="target" />
                                            <div class="text-danger small"
                                                *ngIf="inspectionForm.get('target')?.touched && inspectionForm.get('target')?.invalid"
                                                style="min-height: 1.25rem;"> Enter Valid Number</div>
                                        </div>

                                        <!-- Fresh Cases -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Arrear as On 01 {{ currentMonth?.name }}</label>
                                            <input type="number" class="form-control" min="0" step="1"
                                                formControlName="arrear" />
                                            <div class="text-danger small"
                                                *ngIf="inspectionForm.get('arrear')?.touched && inspectionForm.get('arrear')?.invalid"
                                                style="min-height: 1.25rem;">Enter Valid Number</div>
                                        </div>
                                        <!-- Fresh Cases -->
                                        <div class="col-lg-4 col-md-6 mb-2">
                                            <label class="form-label">Inspection Done during {{ currentMonth?.name
                                                }}</label>
                                            <input type="number" class="form-control" min="0" step="1"
                                                formControlName="noOfInspectionDone" />
                                            <div class="text-danger small"
                                                *ngIf="inspectionForm.get('noOfInspectionDone')?.touched && inspectionForm.get('noOfInspectionDone')?.invalid"
                                                style="min-height: 1.25rem;">Enter Valid Number</div>
                                        </div>



                                    </div>
                                </form>



                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary" (click)="onSubmit()">Save</button>
                            </div>
                        </div>
                    </div>
                </div>



            </div>
        </div>

    </div>
</div>